import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import { GupshupSettingsProvider } from "./context/OnboardContex";
import InteraktCloudSettingsForm from "./components/OnboardingPage";
// import "./App.css";

const theme = createTheme({
  typography: {
    fontFamily: '"Segoe UI", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GupshupSettingsProvider>
        <CssBaseline />
        <InteraktCloudSettingsForm />
      </GupshupSettingsProvider>
    </ThemeProvider>
  );
}

export default App;
